import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'medsurf-text-format',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './text-format.component.html',
    styleUrls: ['./text-format.component.scss'],
    standalone: false
})
export class TextFormatComponent {
  @Input() public text: string;
}
